import $ from 'jquery';

function LastMeta(element) {
  this.$element = $(element);
  this.init();
}

LastMeta.prototype = {
  init() {
    const notLast = this.$element.next().is('.meta-item');
    const isLast = this.$element.next().is('.meta-item.last');
    if (!notLast && !isLast) {
      this.$element.addClass('last');
    }
  },
};

export default LastMeta;
